var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "page-content nestor-bomb-simulator",
        attrs: { id: "resultats" },
      },
      [
        _c("div", { staticClass: "banniere" }, [
          _c("div", {
            staticClass: "logo-lockquest",
            on: { click: _vm.pageBackground_clicked },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "logo-room" }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "latest-score" }, [
          _vm._m(0),
          _vm._v(" "),
          _vm.latest_nestor_session
            ? _c("div", [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.latest_nestor_session.session_time.day) +
                      "/" +
                      _vm._s(_vm.latest_nestor_session.session_time.month)
                  ),
                ]),
                _c("span", [_vm._v(_vm._s(_vm.latest_nestor_session.rank))]),
                _c("span", [
                  _vm._v(_vm._s(_vm.latest_nestor_session.team_name)),
                ]),
                _c(
                  "span",
                  [
                    _vm.latest_nestor_session.boom_was_triggered
                      ? [_c("span", { staticClass: "boom" })]
                      : _vm._l(_vm.latest_nestor_session.bonus, function (num) {
                          return _c("span", { staticClass: "star" })
                        }),
                  ],
                  2
                ),
                _c("span", [_vm._v(_vm._s(_vm.latest_nestor_session.score))]),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _vm.nestor_sessions
          ? _c(
              "div",
              { staticClass: "liste-scores" },
              _vm._l(_vm.nestor_sessions, function (nestor_session) {
                return _c(
                  "div",
                  {
                    class: {
                      first: nestor_session.rank == 1,
                      second: nestor_session.rank == 2,
                      third: nestor_session.rank == 3,
                      default: nestor_session.rank > 3,
                    },
                  },
                  [
                    _c("span", [
                      _vm._v(
                        _vm._s(nestor_session.session_time.day) +
                          "/" +
                          _vm._s(nestor_session.session_time.month)
                      ),
                    ]),
                    _c("span", [_vm._v(_vm._s(nestor_session.rank))]),
                    _c("span", [_vm._v(_vm._s(nestor_session.team_name))]),
                    _c(
                      "span",
                      [
                        nestor_session.boom_was_triggered
                          ? [_c("span", { staticClass: "boom" })]
                          : _vm._l(nestor_session.bonus, function (num) {
                              return _c("span", { staticClass: "star" })
                            }),
                      ],
                      2
                    ),
                    _c("span", [_vm._v(_vm._s(nestor_session.score))]),
                  ]
                )
              }),
              0
            )
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("Date")]),
      _c("span", [_vm._v("Rang")]),
      _c("span", [_vm._v("Équipe")]),
      _c("span", [_vm._v("Bonus")]),
      _c("span", [_vm._v("Score")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }